import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { getWorkerProfileOptions } from '../../../../../../api'
import { EMPTY_LIST } from '../../../../../../constants/common'
import { getItemsFromIdwellApiResponse } from '../../../../../../utils/api'
import { FieldStackedLabel } from '../../../../../Field'
import {
  FormBody,
  FormFieldsContainer,
  FormFieldSelectNG,
  FormInlineNotifications,
  useFormValidationErrorsNotification,
} from '../../../../../Form'
import {
  FormikField,
  getFormikFormFieldErrorProps,
} from '../../../../../Formik'
import {
  toUserSelectItemsFromOption,
  UserMultiSelect,
} from '../../../../../User'
import { RequestProfileWidgetSendNotificationField } from '../../../RequestProfileWidgetSendNotificationField'
import {
  REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_COMMENT,
  REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_IS_INVITATION,
  REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_SIDE_WORKERS,
} from '../../RequestProfileWidgetSideWorkers.constants'

import { useSideWorkersFieldHandlers } from './RequestProfileWidgetSideWorkersFormFields.hooks'

import * as styles from './RequestProfileWidgetSideWorkersFormFields.module.css'

function RequestProfileWidgetSideWorkersFormFields({
  notifications,
  requestId,
  onCancel,
  onRemoveNotification,
  onSetNotification,
}) {
  const { t } = useTranslation()

  const { dirty, isSubmitting, values } = useFormikContext()

  const {
    handleChangeSideWorkers,
    handleInputKeyDown,
    handleSideWorkerSelectClose,
    sideWorkerSelectStatesRef,
  } = useSideWorkersFieldHandlers()

  useFormValidationErrorsNotification({
    onRemoveNotification,
    onSetNotification,
  })

  function handleCancel() {
    onCancel({ dirty })
  }

  return (
    <FormBody
      actionsProps={{
        ButtonAdd: false,
        ButtonClear: false,
        Header: false,
        UploadComponent: false,
        cancelProps: {
          onClick: handleCancel,
        },
        isSubmitting,
        submitProps: {
          isLoading: isSubmitting,
          title: 'Modal.SaveBtnKey',
        },
      }}
    >
      <div className={styles.fields}>
        <FormInlineNotifications notifications={notifications} />
        <FormFieldsContainer>
          <FormikField
            multi
            Component={FormFieldSelectNG}
            Field={FieldStackedLabel}
            Select={UserMultiSelect}
            controlProps={{
              contentProps: {
                inputProps: {
                  placeholder: t(
                    'RequestProfile.ProvidersSideWorkersSelectPlaceholderKey'
                  ),
                  onKeyDown: handleInputKeyDown,
                },
              },
            }}
            emptyValue={EMPTY_LIST}
            fieldComponentProps={{
              label: t('RequestProfile.ProvidersSideWorkersTitleKey', {
                count:
                  values[
                    REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_SIDE_WORKERS
                  ].length,
              }),
            }}
            getData={getWorkerProfileOptions}
            getDataItems={getItemsFromIdwellApiResponse}
            getErrorProps={getFormikFormFieldErrorProps}
            name={REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_SIDE_WORKERS}
            selectStatesRef={sideWorkerSelectStatesRef}
            toPreparedItems={toUserSelectItemsFromOption}
            onChange={handleChangeSideWorkers}
            onCloseDropdown={handleSideWorkerSelectClose}
          />
          <RequestProfileWidgetSendNotificationField
            checkboxFieldName={
              REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_IS_INVITATION
            }
            commentFieldName={
              REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_COMMENT
            }
            disabledTooltipKey='Modal.SendNotificationEmptyAssigneesTypeDisabledCheckboxTooltipKey'
            fieldName={
              REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_SIDE_WORKERS
            }
            requestId={requestId}
          />
        </FormFieldsContainer>
      </div>
    </FormBody>
  )
}

export default RequestProfileWidgetSideWorkersFormFields
